import { Redirect } from "expo-router";
import { useSelector } from "react-redux";

export default function Index() {
  return <Redirect href="/screens/login" />;
}